import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import get from 'lodash/get';
import * as yup from 'yup';

import { convertArrayToObject } from '../../../../../helpers/helpers';
import { errorScroll } from '../../../../../helpers/functions';

import Button from '../../../../../components/Button';
import TextInput from '../../../../../components/input/TextInput';
import StateZip from '../../../components/StateZip';

const AmericanAddressForm = ({
  history,
  i18n,
  setForm: setFormGlobal,
  form: formGlobal,
  setTmpForm,
  tmpform
}) => {
  const { location } = history;
  const { search } = location;
  const [form, setForm] = useState({ ...(formGlobal.address || tmpform.address) });
  const [errors, setErrors] = useState({});

  const handlerSubmit = (e) => {
    e.preventDefault();
    let schema = yup.object().shape({
      address: yup.string().required('required'),
      city: yup.string().required('required'),
      state: yup.object().shape({
        value: yup.string().required('required')
      }),
      zip_code: yup.string().required('required'),
      home_phone: yup
        .string()
        .test('len', i18n('validation.min_length', { min: 10 }), (val) =>
          val && val !== '' ? val.toString().length > 9 : true
        ),
      phone: yup
        .number()
        .test(
          'len',
          i18n('validation.min_length', { min: 10 }),
          (val) => val && val.toString().length > 9
        )
        .typeError('number')
        .required('required')
        .integer('number')
        .positive('number'),
      email: yup.string().email('email').required('required')
    });

    schema
      .validate(form, { abortEarly: false })
      .then(() => {
        setFormGlobal({ ...formGlobal, address: form });
        history.push(`/passpor/registration/job${search}`);
      })
      .catch((err) => {
        setErrors(convertArrayToObject(err.inner, 'path', 'message'));
        errorScroll();
      });
  };

  const handlerChanges = (value, key, errorKey) => {
    setForm({ ...form, [key]: value });
    setErrors({ ...errors, [errorKey ? errorKey : key]: undefined });
  };

  useEffect(() => {
    setTmpForm({ ...tmpform, address: form });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form]);

  return (
    <form onSubmit={handlerSubmit} id='american-address'>
      <div className='form-container'>
        <div className='form-wrap'>
          <div className='title'>
            {i18n('form_personal_data.instruction_american_address')}
          </div>
          <TextInput
            label={i18n('form.address.label')}
            placeholder={i18n('form.address.placeholder')}
            value={get(form, ['address'])}
            inputProps={{
              onChange: (e) => handlerChanges(e.target.value, 'address')
            }}
            errorMessage={
              get(errors, ['address']) && i18n(`validation.${get(errors, ['address'])}`)
            }
          />
          <StateZip
            i18n={i18n}
            form={form}
            handlerChanges={handlerChanges}
            errors={errors}
          />
          <TextInput
            label={i18n('form.phone_home.label')}
            sublabel={i18n('form.at_america')}
            placeholder={i18n('form.phone_home.placeholder')}
            value={get(form, ['home_phone'])}
            inputProps={{
              type: 'number',
              onChange: (e) => handlerChanges(e.target.value, 'home_phone')
            }}
            errorMessage={
              get(errors, ['home_phone']) &&
              i18n(`validation.${get(errors, ['home_phone'])}`)
            }
          />
          <TextInput
            label={i18n('form.phone.label')}
            sublabel={i18n('form.at_america')}
            placeholder={i18n('form.phone.placeholder')}
            prependText='+1'
            value={get(form, ['phone'])}
            inputProps={{
              type: 'number',
              onChange: (e) => handlerChanges(e.target.value, 'phone')
            }}
            errorMessage={
              get(errors, ['phone']) && i18n(`validation.${get(errors, ['phone'])}`)
            }
          />
          <TextInput
            label={i18n('form.email.label')}
            placeholder={i18n('form.email.placeholder')}
            value={get(form, ['email'])}
            inputProps={{
              maxLength: '255',
              onChange: (e) => handlerChanges(e.target.value, 'email')
            }}
            errorMessage={
              get(errors, ['email']) && i18n(`validation.${get(errors, ['email'])}`)
            }
          />
        </div>
      </div>

      <div className='btn-wrap'>
        <Button
          color='link'
          type='button'
          onClick={() => history.push(`/passpor/registration/passpor-visa${search}`)}
        >
          {i18n('cta.cancel')}
        </Button>
        <Button color='primary' type='submit' className='pass-btn'>
          {i18n('cta.next')}
        </Button>
      </div>
    </form>
  );
};

AmericanAddressForm.propTypes = {
  history: PropTypes.object,
  i18n: PropTypes.func,
  setForm: PropTypes.func,
  form: PropTypes.object,
  setTmpForm: PropTypes.func,
  tmpform: PropTypes.object
};

export default withRouter(AmericanAddressForm);
